import React from "react";

/**
 * Dashboard do cliente — app `dash-clientes` (Flask multi-tenant) embutido.
 *
 * Diferente do /dashboard-tnp (que embute um HTML estático da pasta public), aqui o iframe
 * aponta para um app servido em outro caminho, e a entrada é por SSO: o token vem do /login
 * do CRM (`dash_token`, HMAC de 12h) e é trocado por sessão em /sso. O usuário não digita
 * senha nenhuma.
 *
 * O grupo 192 (TNP) não chega aqui: o item de menu não aparece para ele, que continua com a
 * dash própria (/dashboard/tnp/, com as abas de performance e retenção).
 */
/**
 * URL do app do dashboard.
 *
 * Em produção ele é servido pelo nginx no mesmo domínio do CRM (`/dashboard/cliente/`), o que
 * mantém o iframe same-origin. Em desenvolvimento o CRM roda no :3000 e o dash num Flask
 * próprio — apontar para o caminho de produção faria o iframe carregar o próprio index.html
 * do CRA (fallback de SPA) e a tela ficaria EM BRANCO, sem erro nenhum.
 *
 * Por isso a porta de desenvolvimento é detectada aqui, sem exigir configuração: quem roda
 * `npm start` não precisa definir variável nenhuma. REACT_APP_DASH_URL continua tendo
 * precedência para quem quiser apontar para outro lugar.
 */
const DASH_BASE = (() => {
  const configurada = process.env.REACT_APP_DASH_URL;
  if (configurada) return configurada.replace(/\/$/, "");
  const h = typeof window !== "undefined" ? window.location.hostname : "";
  if (h === "localhost" || h === "127.0.0.1") return "http://127.0.0.1:8396";
  return "/dashboard/cliente";
})();

const DashboardCliente = () => {
  const token = localStorage.getItem("dash_token") || "";

  // Sem token: o login é antigo (feito antes desta versão) ou o SSO não está configurado
  // no servidor. Relogar resolve — e é melhor dizer isso do que mostrar um iframe com erro.
  if (!token) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="alert alert-warning">
            <i className="ti ti-alert-circle me-2" />
            Não foi possível abrir o dashboard: sua sessão não tem o acesso liberado.
            <strong> Saia e entre novamente no CRM</strong> para renovar o acesso.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content p-0">
        <iframe
          title="Dashboard"
          src={`${DASH_BASE}/sso?tk=${encodeURIComponent(token)}`}
          style={{
            width: "100%",
            height: "calc(100vh - 60px)",
            border: "none",
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default DashboardCliente;
